import { useMemo } from "react";
import AzulPaymentService from "../services/AzulPaymentService";

interface AzulPaymentFormProps {
  azulPaymentService: AzulPaymentService;
  userId?: string | null;
  branchId?: string | null;
  customOrderId?: string;
}

const AzulPaymentForm = ({ azulPaymentService, userId, branchId, customOrderId }: AzulPaymentFormProps) => {
  const config = useMemo(() => azulPaymentService.getFormConfig(userId, branchId, customOrderId), [azulPaymentService, userId, branchId, customOrderId]);
  const formId = useMemo(() => azulPaymentService.getFormId(), [azulPaymentService]);
  const paymentUrl = useMemo(() => azulPaymentService.getPaymentUrl(), [azulPaymentService]);

  return (
    <form
      action={paymentUrl}
      method="post"
      id={formId}
      name={formId}
      style={{ display: 'none' }}
    >
      <input type="hidden" id="MerchantId" name="MerchantId" value={config.merchantId} />
      <input type="hidden" id="MerchantName" name="MerchantName" value={config.merchantName} />
      <input type="hidden" id="MerchantType" name="MerchantType" value={config.merchantType} />
      <input type="hidden" id="CurrencyCode" name="CurrencyCode" value={config.currencyCode} />
      <input type="hidden" id="OrderNumber" name="OrderNumber" value={config.orderNumber} />
      <input type="hidden" id="Amount" name="Amount" value="15000" />
      <input type="hidden" id="ITBIS" name="ITBIS" value={config.itbis} />
      <input type="hidden" id="ApprovedUrl" name="ApprovedUrl" value={config.approvedUrl} />
      <input type="hidden" id="DeclinedUrl" name="DeclinedUrl" value={config.declinedUrl} />
      <input type="hidden" id="CancelUrl" name="CancelUrl" value={config.cancelUrl} />
      <input type="hidden" id="UseCustomField1" name="UseCustomField1" value={config.useCustomField1} />
      <input type="hidden" id="UseCustomField2" name="UseCustomField2" value={config.useCustomField2} />
      <input type="hidden" id="CustomOrderId" name="CustomOrderId" value={config.customOrderId} />
      {config.logoImageUrl && (
        <input type="hidden" id="LogoImageUrl" name="LogoImageUrl" value={config.logoImageUrl} />
      )}
      <input type="hidden" id="AuthHash" name="AuthHash" value="" />
    </form>
  );
};

export default AzulPaymentForm;

